import './styles/App.css';
import { ethers } from 'ethers';
import PresentFinder from './contracts/PresentFinder.sol/PresentFinder.json';

export default async function connector (presentAddress){
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(presentAddress, PresentFinder.abi, provider)
        const { ethereum } = window
        await ethereum.enable()
        const accounts = await ethereum.request({ method: "eth_accounts" })
        if (accounts.length !== 0) {
            const account = accounts[0]
        } else {
            console.log("No authorized account found")
        }
        return{contract,signer,provider,accounts};
}
